let AwardLettersModalService = function($modal, ApplicationService, AwardLetterModelService) {
    let result = {};
    let url = "fast/submodules/schoolside/applications/submodules/applicationsSubNavbar/partials" +
        "/awardLettersModal.html?v=";
    result.initModal = function(item, index) {
        return $modal.open({
            templateUrl: url + versionNo,
            controller: "AwardLettersModalController",
            resolve: {
                item: function(AwardLetterModelService) {
                    if (item === undefined) {
                        AwardLetterModelService.resolveData();
                        return ApplicationService.getAwardData().awardLetters[AwardLetterModelService.new()];
                    } else {
                        return item;
                    }
                },
                index: function() {
                    if (index === undefined) {
                        return (ApplicationService.getAwardData().awardLetters.length - 1);
                    } else {
                        return index;
                    }
                }
            },
            keyboard: false,
            backdrop: "static"
        });
    };
    return result;
};
applicationsSubNavbar.service("AwardLettersModalService", AwardLettersModalService);
